module.exports = __webpack_public_path__ + "images/柏纳s长图_06-2.jpg?v=29b69d79";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan2/柏纳s长图_06-2.jpg
 ** module id = 165
 ** module chunks = 1 2
 **/